import { render, staticRenderFns } from "./musicplay.vue?vue&type=template&id=a1a90616&"
import script from "./musicplay.vue?vue&type=script&lang=js&"
export * from "./musicplay.vue?vue&type=script&lang=js&"
import style0 from "./musicplay.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports